module.exports = __webpack_public_path__ + "img/htc-desire-10.b0fbfa29.jpg";